<template>
  <div style="display:inline-flex;align-items:center;margin-bottom:0;">
    <el-select @change="putSearchWhse" ref="whId" v-model="whId" :placeholder="$t('SearchWhseClient.whName')" size="small" style="width:180px;">
      <el-option v-for="(whse,index) in this.whseData" :key="index" :value="whse.whId" :label="whse.name"/>
    </el-select>
  </div>
</template>

<script>
import { hasPermission } from '@/permission/index.js'
export default {
  name: 'GetSearchWhse',
  props: {
    icon: {  // 显示图标
      type: String,
      default: ''
    },
    size: {  // 尺寸
      type: String,
      default: 'mini'
    },
    type: {  // 类型
      type: String,
      default: null
    },
    loading: {  // 加载标识
      type: Boolean,
      default: false
    },
    disabled: {  // 是否禁用
      type: Boolean,
      default: false
    },
    perms: {  // 权限标识，外部使用者传入
      type: String,
      default: null
    }
  },
  data() {
    return {
      whId:'',
      whseData:Object,
    }
  },
  methods: {
    //获取仓库下拉列表
    getWhse: function (){
      let user = sessionStorage.getItem('user')
      let objUserName = {userName:user}
      this.$wmsApi.globalOption.getWhse(objUserName)
      .then(res =>
        {
          //请求返回的数据
          this.whseData = res.data
          this.whId = this.whseData[0].whId
          this.putSearchWhse()
        })
    },
    putSearchWhse: function (){
      return this.$emit('search-whse-event',this.whId);
    },
    hasPerms: function (perms) {
      // 根据权限标识和外部指示状态进行权限判断
      return hasPermission(perms) & !this.disabled
    }
  },
  created() {
    this.getWhse()
  },
  mounted() {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Core/SearchWhse.vue